import { useState, useEffect } from "react";
import { FaRegClock } from "react-icons/fa";
import step_1 from "Assets/dashboard_step1.png";
import step_2 from "Assets/dashboard_step2.png";
import step_3 from "Assets/dashboard_step3.png";
import { get_Years } from "Services/Requests";
import DashboardClasses from "./Dashboard.module.css";
import { getFromLocalStorage } from "Utils/Util";
import { showSuccessNotification } from "Utils/Notifications";
import { showWarningAlert } from "Utils/Alerts";
import { useNavigate } from "react-router";
import { useBlocker } from "react-router";
import { useStore } from "Store";
function Dashboard() {
    const [userDetails] = useState<any>(getFromLocalStorage("UserDetails"));
    const [Years, setYears] = useState([
        { year: "", id: "", main_status: "", sub_status: "" },
    ]);
    const [yearId, setYearId] = useState<any>(0);
    const { setmainStatus, setSelectedYear, setIsDisabled, currentYear } =
        useStore((state: any) => state);
    const [block, setblock] = useState(true);
    const [loading, setLoading] = useState(false);
    const Navigate = useNavigate();

    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await get_Years();
            setTimeout(() => {
                setLoading(false);
            }, 300);
            if (response.data.status == 1) {
                setYears(response?.data?.tax_file_years);
                if (response.data?.tax_file_years.length > 0) {
                    if (localStorage.getItem("main_status")) {
                        setmainStatus(localStorage.getItem("main_status"));
                        setYearId(localStorage.getItem("Year_id"));
                        setSelectedYear(localStorage.getItem("selectedYear"));
                        setIsDisabled(
                            currentYear !=
                                localStorage.getItem("selectedYear") &&
                                String(Number(currentYear) - 1) !=
                                    localStorage.getItem("selectedYear")
                        );
                    } else {
                        localStorage.setItem(
                            "Year_id",
                            response.data?.tax_file_years[0].id
                        );
                        localStorage.setItem(
                            "sub_status",
                            response.data?.tax_file_years[0].sub_status
                        );
                        localStorage.setItem(
                            "main_status",
                            response.data?.tax_file_years[0].main_status
                        );
                        setmainStatus(
                            response.data?.tax_file_years[0].main_status
                        );
                        setYearId(response.data?.tax_file_years[0].id);
                        localStorage.setItem(
                            "selectedYear",
                            response.data?.tax_file_years[0].year
                        );
                        setSelectedYear(response.data?.tax_file_years[0].year);
                        console.log(
                            currentYear !=
                                response.data?.tax_file_years[0].year,
                            currentYear
                        );
                        setIsDisabled(
                            currentYear !=
                                response.data?.tax_file_years[0].year &&
                                currentYear - 1 !=
                                    response.data?.tax_file_years[0].year
                        );
                    }
                }
            } else {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team"
                );
                setLoading(false);
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        GetDetails();
    }, []);
    const changeHandler = (e: any) => {
        let [selected] = Years.filter((item) => item.id == e.target.value);
        localStorage.setItem("sub_status", selected.sub_status);
        localStorage.setItem("main_status", selected.main_status);
        setmainStatus(selected.main_status);
        localStorage.setItem("Year_id", e.target.value);
        setYearId(e.target.value);
        localStorage.setItem("selectedYear", selected.year);
        setSelectedYear(selected.year);
        setblock(false);
        Navigate("/auth/basic-info/Profile-info");
        setIsDisabled(
            currentYear != selected.year &&
                String(currentYear - 1) != selected.year
        );
    };

    return (
        <>
            <div className={DashboardClasses["Container"]}>
                <header>
                    <h3>
                        Hello! Welcome to <br /> <span>Serene Tax!</span>
                    </h3>
                    <p>
                        <FaRegClock />
                        Office Timings: 9 AM EST to 11 PM EST
                    </p>
                </header>

                <div className={DashboardClasses["tax-filing"]}>
                    <p>
                        {userDetails?.users_id} <br />
                        <span>Your Unique file number</span>
                    </p>
                    <div>
                        <p>Choose your Year</p>
                        <select
                            name=""
                            id=""
                            onChange={changeHandler}
                            value={yearId || 0}>
                            <option value={0} disabled>
                                Select Year
                            </option>
                            {Years?.map((item) => (
                                <option value={item.id}>{item?.year}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className={DashboardClasses["easy-steps"]}>
                    <h3>3 Easy steps to process your return</h3>
                    <div className={DashboardClasses["step-wrapper"]}>
                        <div
                            className={DashboardClasses["step_1"]}
                            onClick={() =>
                                Navigate("/auth/basic-info/Profile-info")
                            }>
                            <img src={step_1} alt="" />
                            <p>Develop your information</p>
                        </div>
                        <div
                            className={DashboardClasses["step_2"]}
                            onClick={() => {
                                Navigate("/auth/upload-document");
                            }}>
                            <img src={step_2} alt="" />
                            <p>upload documents</p>
                        </div>
                        <div
                            className={DashboardClasses["step_3"]}
                            onClick={() => {
                                Navigate("/auth/Tax-Summary");
                            }}>
                            <img src={step_1} alt="" />
                            <p>analyse returns & make payments</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Dashboard;
